/*
 * @Author: chenyourong
 * @Date: 2021-11-18 23:21:54
 * @LastEditors: chenyourong
 * @LastEditTime: 2025-11-18 11:30:16
 * @Description: 
 * @FilePath: /vue-admin-template-master/src/permission.js
 */
import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'
import Cookies from 'js-cookie'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login/platform','/login/channel','/login/merchant','/login/store'] // no redirect whitelist

router.beforeEach(async(to, from, next) => {
  Cookies.set('isLock', +Cookies.get('type'))
  if (whiteList.indexOf(to.path) === -1) {
    // in the free login whitelist, go directly
    NProgress.start()
  }

// console.log("🔍 ~ router.beforeEach() callback ~ src/permission.js:21 ~ to:", to)
  // start progress bar
  // NProgress.start()

  // set page title
  document.title = getPageTitle(to.meta.title)

  // determine whether the user has logged in
  const hasToken = getToken()

  if (hasToken) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({ path: '/' })
      NProgress.done()
    } else {
      const hasGetUserInfo = store.getters.roles
      if (hasGetUserInfo.length) {
        next()
      } else {
        try {
          // get user info
          // await store.dispatch('user/getInfo')
          // 这里修改权限
          const { roles } = await store.dispatch('user/getInfo')
          // const roles = 'admin';
          
          const accessRoutes = await store.dispatch('permission/generateRoutes', roles)
          debugger
          router.addRoutes(accessRoutes)
          next({ ...to, replace: true })
          // next()
        } catch (error) {
          // remove token and go to login page to re-login
          await store.dispatch('user/resetToken')
          Message.error(error || 'Has Error')
          next(`/login`)
          NProgress.done()
        }
      }
    }
  } else {
    /* has no token*/

    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      // next(`/login/platform?redirect=${to.path}`)
      // next(`/login/platform`)
      next(`${whiteList[+Cookies.get('type') - 1]}`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
